import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  configureLabel: {
    defaultMessage: 'Configure Label',
    description: 'rateViewer.configureLabel',
    id: 'V7vApW',
  },
  rateViewerHeader: {
    defaultMessage: 'Rates',
    description: 'Header for the rate viewer',
    id: 'VkJ2Vg',
  },
  rateViewerProgress: {
    defaultMessage: '{rateProvidersLoadedCount} out of {rateProvidersRequestedCount} carriers available',
    description: 'Progress for loading rate viewer rates',
    id: 'hi3vpZ',
  },
  viewDropdownLabel: {
    defaultMessage: 'View By:',
    description: 'Label for the dropdown to select the rate viewer view',
    id: 'DaZwF9',
  },
  allRatesOption: {
    defaultMessage: 'All Rates',
    description: 'Option to view all rates from all providers',
    id: 'D9Vngm',
  },
  carriersOption: {
    defaultMessage: 'Carriers',
    description: 'Option to view rates grouped by carrier',
    id: 'sjPki5',
  },
  unnamedProviderDisplayName: {
    defaultMessage: '{labelProviderName} Account #: {accountNumber}',
    description: 'Display name for a label provider account that does not have a name',
    id: 'Qrl6Ni',
  },
  allRatesErrorMessage: {
    defaultMessage: 'One or more carriers could not return a rate: <p>{accountsWithErrors}.</p> Check the shipment details and try again.',
    description: 'Error message when rate providers fail to get rates',
    id: 'dTABc+',
  },
  recommendedTag: {
    defaultMessage: 'Recommended',
    description: 'Label for recommended shipping service',
    id: 'pCbuBw',
  },
  cheapestTag: {
    defaultMessage: 'Cheapest',
    description: 'Label for the cheapest rate',
    id: '4nzWuy',
  },
  cheapestTagTooltip: {
    defaultMessage: 'Lowest cost option.',
    description: 'Tooltip for the cheapest rate tag',
    id: 'H28sgo',
  },
  fastestTag: {
    defaultMessage: 'Fastest',
    description: 'Label for the fastest rate',
    id: 'HMDZM8',
  },
  fastestTagTooltip: {
    defaultMessage: 'Fastest option at the lowest price.',
    description: 'Tooltip for the fastest rate tag',
    id: '8Ex7m4',
  },
  bestValueTag: {
    defaultMessage: 'Best Value',
    description: 'Label for the best value rate',
    id: '+G21tu',
  },
  bestValueTagTooltip: {
    defaultMessage: 'Lowest cost option arriving within 4 days.',
    description: 'Tooltip for the best value rate tag',
    id: '+1jU3p',
  },
  twoDayTag: {
    defaultMessage: '2 Day',
    description: 'Label for the 2 day rate',
    id: 'xymSW+',
  },
  automatedRatesSectionHeader: {
    defaultMessage: 'Automated Rates',
    description: 'Section header for automated rate options',
    id: 'pfAhvn',
  },
  carrierAccountsSectionHeader: {
    defaultMessage: 'Carrier Accounts',
    description: 'Section header for carrier account rate options',
    id: 'xCxhMK',
  },
  noRates: {
    defaultMessage: 'Rate Browsing Requires Shipment Details',
    description: 'Message title when no rates are available',
    id: 'mK/UtG',
  },
  needInfoMessage: {
    defaultMessage: 'Enter your shipment details to view available services and estimated rates.',
    description: 'Message telling the user to fill out the form to get rates',
    id: 'Gsd09u',
  },
  fetchingRates: {
    defaultMessage: 'Fetching Rates...',
    description: 'Loading message when fetching rates',
    id: '/jTaHR',
  },
  unknownLabelProviderLabel: {
    defaultMessage: 'Unknown Label Provider',
    description: 'Unknown Label Provider label to show when the label provider is not found',
    id: '2N9nQJ',
  },
  multiPackageRateViewerCaption: {
    defaultMessage: 'Multi-Package ({count})',
    description: 'Caption for the multi-package rate viewer',
    id: '9n8a5V',
  },
  walletRequiredMessage: {
    defaultMessage: 'Please complete wallet activation setup in order to view rates',
    description: 'Message title when a wallet is required to use the rate browser',
    id: 'ctVpuH',
  },
  activateWallet: {
    defaultMessage: 'Activate Wallet',
    description: 'Button text to activate wallet',
    id: 'IbvGzu',
  },
  emptyMessageRateViewer: {
    defaultMessage: 'Fill out the information on the left to get a list of rates.',
    description: 'rateViewer.emptyMessage',
    id: '6bjMqQ',
  },
  upgradePromotionalBannerTitle: {
    defaultMessage: 'Upgrade to a paid plan to unlock improved wallet rates on this shipment and future labels.',
    description: 'Message encouraging users to upgrade to a paid plan for better wallet rates',
    id: 'lDV2sr',
  },
});
